/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddMoreRollbackTimeBody,
    GetOrdersParams,
    ManuallyTriggerRollbackBody,
    OrdersSuccessResponseResponse,
    PaymentExpiredRollbackByReservationIdParams,
    RequestStatusResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get orders matching the filters
 */
export const getOrders = (params?: GetOrdersParams, signal?: AbortSignal) => {
    return customInstance<OrdersSuccessResponseResponse>({
        url: `/orders`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetOrdersQueryKey = (params?: GetOrdersParams) => {
    return [`/orders`, ...(params ? [params] : [])] as const;
};

export const getGetOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof getOrders>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetOrdersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrders>>> = ({ signal }) =>
        getOrders(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getOrders>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrders>>>;
export type GetOrdersQueryError = APIErrorResponseResponse;

/**
 * @summary Get orders matching the filters
 */

export function useGetOrders<
    TData = Awaited<ReturnType<typeof getOrders>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetOrdersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Extend order rollback time
 */
export const addMoreRollbackTime = (
    id: number,
    addMoreRollbackTimeBody: AddMoreRollbackTimeBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/orders/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addMoreRollbackTimeBody,
    });
};

export const getAddMoreRollbackTimeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addMoreRollbackTime>>,
        TError,
        { id: number; data: AddMoreRollbackTimeBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addMoreRollbackTime>>,
    TError,
    { id: number; data: AddMoreRollbackTimeBody },
    TContext
> => {
    const mutationKey = ['addMoreRollbackTime'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addMoreRollbackTime>>,
        { id: number; data: AddMoreRollbackTimeBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return addMoreRollbackTime(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddMoreRollbackTimeMutationResult = NonNullable<
    Awaited<ReturnType<typeof addMoreRollbackTime>>
>;
export type AddMoreRollbackTimeMutationBody = AddMoreRollbackTimeBody;
export type AddMoreRollbackTimeMutationError = APIErrorResponseResponse;

/**
 * @summary Extend order rollback time
 */
export const useAddMoreRollbackTime = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addMoreRollbackTime>>,
        TError,
        { id: number; data: AddMoreRollbackTimeBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addMoreRollbackTime>>,
    TError,
    { id: number; data: AddMoreRollbackTimeBody },
    TContext
> => {
    const mutationOptions = getAddMoreRollbackTimeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Manually trigger rollback of an order
 */
export const manuallyTriggerRollback = (
    id: number,
    manuallyTriggerRollbackBody: ManuallyTriggerRollbackBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/orders/${id}/rollback`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: manuallyTriggerRollbackBody,
    });
};

export const getManuallyTriggerRollbackMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof manuallyTriggerRollback>>,
        TError,
        { id: number; data: ManuallyTriggerRollbackBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof manuallyTriggerRollback>>,
    TError,
    { id: number; data: ManuallyTriggerRollbackBody },
    TContext
> => {
    const mutationKey = ['manuallyTriggerRollback'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof manuallyTriggerRollback>>,
        { id: number; data: ManuallyTriggerRollbackBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return manuallyTriggerRollback(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ManuallyTriggerRollbackMutationResult = NonNullable<
    Awaited<ReturnType<typeof manuallyTriggerRollback>>
>;
export type ManuallyTriggerRollbackMutationBody = ManuallyTriggerRollbackBody;
export type ManuallyTriggerRollbackMutationError = APIErrorResponseResponse;

/**
 * @summary Manually trigger rollback of an order
 */
export const useManuallyTriggerRollback = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof manuallyTriggerRollback>>,
        TError,
        { id: number; data: ManuallyTriggerRollbackBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof manuallyTriggerRollback>>,
    TError,
    { id: number; data: ManuallyTriggerRollbackBody },
    TContext
> => {
    const mutationOptions = getManuallyTriggerRollbackMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Rollback the pending order by reservation id if payment expired
 */
export const paymentExpiredRollbackByReservationId = (
    reservationId: number,
    params?: PaymentExpiredRollbackByReservationIdParams,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/orders/${reservationId}/payment-deadline-rollback`,
        method: 'PATCH',
        params,
    });
};

export const getPaymentExpiredRollbackByReservationIdMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof paymentExpiredRollbackByReservationId>>,
        TError,
        { reservationId: number; params?: PaymentExpiredRollbackByReservationIdParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof paymentExpiredRollbackByReservationId>>,
    TError,
    { reservationId: number; params?: PaymentExpiredRollbackByReservationIdParams },
    TContext
> => {
    const mutationKey = ['paymentExpiredRollbackByReservationId'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof paymentExpiredRollbackByReservationId>>,
        { reservationId: number; params?: PaymentExpiredRollbackByReservationIdParams }
    > = (props) => {
        const { reservationId, params } = props ?? {};

        return paymentExpiredRollbackByReservationId(reservationId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type PaymentExpiredRollbackByReservationIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof paymentExpiredRollbackByReservationId>>
>;

export type PaymentExpiredRollbackByReservationIdMutationError = APIErrorResponseResponse;

/**
 * @summary Rollback the pending order by reservation id if payment expired
 */
export const usePaymentExpiredRollbackByReservationId = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof paymentExpiredRollbackByReservationId>>,
        TError,
        { reservationId: number; params?: PaymentExpiredRollbackByReservationIdParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof paymentExpiredRollbackByReservationId>>,
    TError,
    { reservationId: number; params?: PaymentExpiredRollbackByReservationIdParams },
    TContext
> => {
    const mutationOptions = getPaymentExpiredRollbackByReservationIdMutationOptions(options);

    return useMutation(mutationOptions);
};
